import { render, staticRenderFns } from "./DrugTable.vue?vue&type=template&id=2542d2e5&scoped=true"
import script from "./DrugTable.vue?vue&type=script&lang=js"
export * from "./DrugTable.vue?vue&type=script&lang=js"
import style0 from "./DrugTable.vue?vue&type=style&index=0&id=2542d2e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2542d2e5",
  null
  
)

export default component.exports